<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de carretas">
        <div class="table-responsive">
          <div class="form-group form-inline pull-left">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar..."> &nbsp;
          </div>
          <div class="form-group form-inline pull-right">
            <button @click="newCart" type="button" class="btn btn-primary">Nuevo</button>
          </div>
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Placa</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @contextmenu.prevent="selectCart(cart, k)"
                v-for="(cart, k) in paginated('filteredCarts')"
                :key="k"
              >
                <td>{{cart.plate}}</td>
              </tr>
            </tbody>
          </table>
          <paginate name="filteredCarts" :list="filteredCarts" class="paginate-list" :per="10"></paginate>
          <paginate-links
            for="filteredCarts"
            :limit="5"
            :show-step-links="true"
            :step-links="{
                next: '>>',
                prev: '<<'
              }"
            :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
          ></paginate-links>
          <context-menu id="context-menu" ref="ctxMenu">
            <li v-on:click="editCart" class="ctx-item">Editar</li>
            <li class="ctx-item">Eliminar</li>
          </context-menu>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import contextMenu from "vue-context-menu";
import api from "@/helpers/api";
import moment from "moment";

export default {
  components: { contextMenu },
  data() {
    return {
      carts: [],
      paginate: ["filteredCarts"],
      search: ""
    };
  },
  methods: {
    editCart() {
      this.$router.push({
        path: `/cart/edit/${this.cart.id}`,
        params: { id: this.cart.id }
      });
    },
    newCart() {
      this.$router.push({
        path: `/cart/new`
      });
    },
    selectCart(cart, key) {
      this.cart = cart;
      this.key = key;
      this.$refs.ctxMenu.open();
    }
  },
  mounted() {
    api.get("/carts").then(response => {
      console.log(response);
      this.carts = response.carts;
    });
  },
  computed: {
    filteredCarts() {
      return this.carts.filter(cart => {
        return cart.plate.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  }
};
</script>
